export const BOOKING_URL = '/booking.pl';
export const SETTINGS_URL = '/settings.pl';
export const BILLING_URL = '/billing.pl';
export const ACCOUNTING_URL = '/accounting.pl';
export const CONTACTS_URL = '/contacts.pl';
export const TRAVEL_URL = '/travel.pl';
export const MODIFICATION_URL = '/modify.pl';
export const MEMO_URL='/memos.pl'
export const EXT_REQUEST="/ext_request.pl"
export const HEART_BEAT_URL="/system_heartbeat.pl"
export const LABEL_URL="/label.pl"
export const BELIEVE_CONTROLLER_URL="/believe_controller.pl"
export const DISTRIBUTION_URL="/distribution.pl"
export const JSONAPI_URL="/jsonapi.pl"
export const FILE_URL="/files.pl"
export const TASK_URL="/tasks.pl"
